/** Headers a manager tab sends with the login it is showing (lower-case, as Express reads them). */
export const TAB_USER_HEADER = 'x-tr-tab-user';
export const TAB_LOCATION_HEADER = 'x-tr-tab-location';
/** Location header value for a tab holding a user-level token (no location claim). */
export const TAB_NO_LOCATION = 'none';
/** `code` in the 409 body when a request's token does not match the tab that sent it. */
export const TAB_IDENTITY_MISMATCH = 'TAB_IDENTITY_MISMATCH';
